<div class="message-table-wrapper" [class.compact]="content.compact">
  <table class="message-table">
    @if (content.caption) {
      <caption class="table-caption">{{ content.caption }}</caption>
    }
    <thead>
      <tr>
        @for (column of content.columns; track column.key) {
          <th>{{ column.label }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of content.rows; track $index) {
        <tr>
          @for (column of content.columns; track column.key) {
            <td [class.compact-cell]="content.compact">
              {{ formatCellValue(row[column.key]) }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

